/**
 * @generated SignedSource<<b7f57b17d8eca3519b5ded75652e2683>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSalesOrderInput = {
  accountID: string;
  userID: string;
  contactID?: number | null;
  customerEmail: string;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  subAmount?: number | null;
  taxAmount?: number | null;
  totalAmount?: number | null;
  discountAmount?: number | null;
  grandAmount?: number | null;
  currencyCode?: string | null;
  status?: string | null;
  paymentTerms?: PaymentTermsInput | null;
  salesOrderItems?: ReadonlyArray<SalesOrderItemInput> | null;
  type?: string | null;
  meta?: any | null;
};
export type PaymentTermsInput = {
  dueDate?: any | null;
};
export type SalesOrderItemInput = {
  productID?: string | null;
  name?: string | null;
  quantity: number;
  price: number;
  discount: number;
  serviceType?: string | null;
  description?: string | null;
};
export type salesOrderWithItemsCreateMutation$variables = {
  input: CreateSalesOrderInput;
};
export type salesOrderWithItemsCreateMutation$data = {
  readonly createSalesOrderWithItems: boolean;
};
export type salesOrderWithItemsCreateMutation = {
  variables: salesOrderWithItemsCreateMutation$variables;
  response: salesOrderWithItemsCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "createSalesOrderWithItems",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesOrderWithItemsCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesOrderWithItemsCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7a6f57b549112249cda26bf0a4a05210",
    "id": null,
    "metadata": {},
    "name": "salesOrderWithItemsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation salesOrderWithItemsCreateMutation(\n  $input: CreateSalesOrderInput!\n) {\n  createSalesOrderWithItems(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "04a1821f9c8576c4cd0584fc7ae5207e";

export default node;
